import { gql } from 'graphql-request';
import { request } from '@/utilities/graphQLClient';

import { QueryContext, QueryResponse } from './types';

import { COMPANY_FRAGMENT } from '@/pages/Narrative/hooks/useNarrative/companyFragmentDeprecated';
import { NARRATIVE_FRAGMENT } from '@/pages/Narrative/hooks/useNarrative/narrativeFragmentDeprecated';

// sharePriceAtPublish is a non-nullable field only available for narratives and not legacy fair values
export const queryFn = async ({ queryKey: [_, slug] }: QueryContext) => {
  const { Narrative } = await request<QueryResponse>(
    gql`
      query Narrative($slug: String!) {
        Narrative(slug: $slug) {
          ...NarrativeFields
          valuations {
            sharePriceAtPublish
          }
          company {
            ...CompanyFields
          }
        }
      }
      ${NARRATIVE_FRAGMENT}
      ${COMPANY_FRAGMENT}
    `,
    { slug }
  );

  return Narrative;
};
